/* SENZA DIRLO - apertura: l'ago che scrive la frase.
   Regola di sicurezza: lo stato di riposo e' "frase tutta visibile".
   Il ritaglio si stringe solo quando l'animazione e' confermata viva
   (secondo fotogramma utile), e una garanzia a tempo la riapre comunque. */
window.SDApertura = function(id, ritmoMs){
  "use strict";
  var root = document.getElementById(id);
  if(!root){ return; }
  var frasi = [];
  try{ frasi = JSON.parse(root.querySelector("[data-frasi]").textContent); }catch(e){ return; }
  if(!frasi.length){ return; }

  var svg       = root.querySelector("[data-svg]");
  var metro     = root.querySelector("[data-metro]");
  var pieno     = root.querySelector("[data-pieno]");
  var taglio    = root.querySelector("[data-taglio]");
  var tracciato = root.querySelector("[data-tracciato]");
  var agog      = root.querySelector("[data-agog]");
  var vh        = root.querySelector("[data-vh]");
  var pall      = root.querySelector("[data-fili]").children;
  var Y = 210, BASE = 176, CORSA = 4200;
  var ultima = frasi[0], indice = 0;
  var anim = null, reteIniziale = null, garanzia = null, fermo = false;
  try{ fermo = window.matchMedia("(prefers-reduced-motion: reduce)").matches; }catch(e){}

  function tuttaVisibile(){
    taglio.setAttribute("x", -4000);
    taglio.setAttribute("width", 12000);
    agog.classList.remove("sd-inMano");
  }
  function spegniTimer(){
    if(anim){ cancelAnimationFrame(anim); anim = null; }
    if(reteIniziale){ clearTimeout(reteIniziale); reteIniziale = null; }
    if(garanzia){ clearTimeout(garanzia); garanzia = null; }
  }

  function percorso(testo, da, a){
    var p = [[da, Y]], i, r;
    for(i = 0; i < testo.length; i++){
      if(testo.charAt(i) === " "){ continue; }
      try{ r = metro.getExtentOfChar(i); }catch(e){ continue; }
      if(!r || !r.width){ continue; }
      var x1 = r.x, x2 = r.x + r.width;
      var su  = Y - (Y - r.y) * 0.82;
      var giu = Y + ((r.y + r.height) - Y) * 0.72;
      p.push([x1 + r.width * 0.10, giu]);
      p.push([x1 + r.width * 0.42, su]);
      p.push([x1 + r.width * 0.70, giu]);
      p.push([x2 - r.width * 0.06, su + (giu - su) * 0.42]);
    }
    p.push([a, Y]);
    var d = "M " + p[0][0].toFixed(1) + " " + p[0][1].toFixed(1);
    for(var k = 1; k < p.length - 1; k++){
      var mx = (p[k][0] + p[k+1][0]) / 2, my = (p[k][1] + p[k+1][1]) / 2;
      d += " Q " + p[k][0].toFixed(1) + " " + p[k][1].toFixed(1) + " " + mx.toFixed(1) + " " + my.toFixed(1);
    }
    var u = p[p.length - 1];
    return d + " L " + u[0].toFixed(1) + " " + u[1].toFixed(1);
  }

  function morbida(t){ return t < 0.5 ? 2*t*t : 1 - Math.pow(-2*t + 2, 2) / 2; }

  function scrivi(f, animare){
    spegniTimer();
    var testo = f.testo;
    vh.textContent = testo;
    metro.textContent = testo;
    metro.style.fontSize = BASE + "px";
    var w;
    try{ w = metro.getComputedTextLength(); }catch(e){ w = 0; }
    if(!w){ w = testo.length * BASE * 0.42; }
    var stretto = window.innerWidth < 900;
    var largoMax = stretto ? 900 : 1160;
    var fs = BASE;
    if(w > largoMax){
      fs = BASE * (largoMax / w);
      metro.style.fontSize = fs + "px";
      try{ w = metro.getComputedTextLength() || largoMax; }catch(e){ w = largoMax; }
    }
    pieno.style.fontSize = fs + "px";
    pieno.textContent = testo;

    var aria = stretto ? 46 : 190;
    var x0 = 800 - w/2, x1 = 800 + w/2;
    svg.setAttribute("viewBox", (x0 - aria) + " 0 " + (w + aria*2) + " 320");
    var da = x0 - (stretto ? 26 : 58);
    var a  = x1 + (stretto ? 26 : 52);

    tuttaVisibile();
    if(!animare || fermo){ return; }

    tracciato.setAttribute("d", percorso(testo, da, a));
    var L = 0;
    try{ L = tracciato.getTotalLength(); }catch(e){ L = 0; }
    if(!L){ return; }

    var t0 = null, avanti = da, conta = 0;

    reteIniziale = setTimeout(function(){ if(conta < 2){ spegniTimer(); tuttaVisibile(); } }, 1200);
    garanzia     = setTimeout(function(){ spegniTimer(); tuttaVisibile(); }, CORSA + 1600);

    function passo(ora){
      conta++;
      if(conta === 1){ anim = requestAnimationFrame(passo); return; }
      if(conta === 2){
        t0 = ora;
        if(reteIniziale){ clearTimeout(reteIniziale); reteIniziale = null; }
        taglio.setAttribute("x", da);
        taglio.setAttribute("width", 0.1);
        agog.classList.add("sd-inMano");
      }
      var t = Math.min((ora - t0) / CORSA, 1);
      var pt = tracciato.getPointAtLength(morbida(t) * L);
      agog.setAttribute("transform", "translate(" + pt.x.toFixed(1) + "," + pt.y.toFixed(1) + ")");
      if(pt.x > avanti){ avanti = pt.x; }
      taglio.setAttribute("width", Math.max(avanti - da, 0.1));
      if(t < 1){ anim = requestAnimationFrame(passo); }
      else { spegniTimer(); tuttaVisibile(); }
    }
    agog.setAttribute("transform", "translate(" + da + "," + Y + ")");
    anim = requestAnimationFrame(passo);
  }

  function mostra(i, animare){
    var f = frasi[i];
    ultima = f; indice = i;
    root.style.setProperty("--filo", f.filo);
    root.style.setProperty("--fondo", f.fondo);
    root.style.setProperty("--inchiostro", f.inchiostro);
    scrivi(f, animare);
    for(var k = 0; k < pall.length; k++){ pall[k].className = (k === i) ? "sd-acceso" : ""; }
  }

  function avvia(){
    mostra(0, true);
    if(frasi.length < 2 || fermo){ return; }
    setInterval(function(){
      if(document.hidden){ return; }
      mostra((indice + 1) % frasi.length, true);
    }, ritmoMs || 8000);
  }

  var partito = false;
  function unaVolta(){ if(!partito){ partito = true; avvia(); } }
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(unaVolta).catch(unaVolta); }
  setTimeout(unaVolta, 2500);

  document.addEventListener("visibilitychange", function(){
    if(!document.hidden && !anim){ mostra(indice, false); }
  });

  var attesa;
  window.addEventListener("resize", function(){
    clearTimeout(attesa);
    attesa = setTimeout(function(){ scrivi(ultima, false); }, 250);
  });
};
